import { useAuthContext } from '@hooks/use-auth-context';
import { selectUserContactCount } from '@reducers/user/stats';
import { useSelector } from 'react-redux';

export const useContactLimitExceeded = (): boolean => {
  const { contactLimit } = useAuthContext();
  const userContactCount = useSelector(selectUserContactCount);
  return (
    contactLimit === undefined ||
    (contactLimit !== null && userContactCount && userContactCount >= contactLimit)
  );
};
